// extracted by mini-css-extract-plugin
export default {"root":"InlineFormatToolbar-modules__root__hKGmG","button":"InlineFormatToolbar-modules__button__LDjHp"};